import {MESSAGE_RECEIVE, MESSAGE_SEND} from '@glark-newco/game-library';

export const LOBBY_BACKGROUND = 'lobby_bg';
export const GAME_BACKGROUND = 'game_bg';
export const PLAY_BACKGROUND = 'play_bg';
export const TIME_PANEL = 'time_panel';
export const TILE_BACKGROUND = 'single_tile';
export const OVERLAY = 'overlay';
export const AVATAR_OPTIONS_PANEL = 'avatar_options_panel';
export const SYMBOLS = 'tiles';
export const CLOSE_ICON = 'close_icon';
export const CROSS = 'cross';
export const TICK = 'tick';
export const CONFETTI = 'confetti';
export const GAMEOVER = 'gameover';
export const PARTYPOPPER = 'partypopper';
export const STREAMERS = 'streamers';
export const CONGRATULATIONS = 'congratulations';
export const AVATAR_OPTIONS = 'avatar_options';
export const AVATAR_TRIMMED_OPTIONS = 'avatar_trimmed_options';
export const PROGRESS_GRADIENT_RED = 'progress_gradient_red';
export const PROGRESS_GRADIENT_GREEN = 'progress_gradient_green';
export const RULES_BUTTON = 'rules_button';
export const RULES_BUTTON_HOVER = 'rules_button_hover';
export const RULES_BACKGROUND = 'rules_background_parchment';

export const APPLAUSE = 'applause';
export const GAMEOVER_SOUND = 'gameover_sound';
export const CLICK = 'click';
export const DRAG = 'drag';
export const FLIP = 'flip';
export const INCORRECT = 'incorrect';
export const PLACE = 'place';
export const CRACKLING_FIRE = 'crackling_fire';
export const TENSION = 'tension';

export const assetManifest = {
    bundles: [
        {
            name: 'load-screen',
            assets: [
                {name: LOBBY_BACKGROUND, srcs: '../images/Signlines-lobby-background.png'},
                {name: GAME_BACKGROUND, srcs: '../images/Signlines-game-background.png'},
                {name: PLAY_BACKGROUND, srcs: '../images/Signlines-play-background.png'},
                {name: TIME_PANEL, srcs: '../images/Signlines-time-panel.png'},
                {name: TILE_BACKGROUND, srcs: '../images/Signlines-single-tile.png'},
                {name: OVERLAY, srcs: '../images/Signlines-overlay.png'},
                {name: AVATAR_OPTIONS_PANEL, srcs: '../images/Signlines-avatar-options-panel.png'},
                {name: SYMBOLS, srcs: '../images/Signlines-tiles.json'},
                {name: CLOSE_ICON, srcs: '../images/close-icon.svg'},
                {name: CROSS, srcs: '../images/cross.svg'},
                {name: TICK, srcs: '../images/tick.svg'},
                {name: CONFETTI, srcs: '../images/confetti.svg'},
                {name: GAMEOVER, srcs: '../images/gameover.svg'},
                {name: PARTYPOPPER, srcs: '../images/partypopper.svg'},
                {name: STREAMERS, srcs: '../images/streamers.svg'},
                {name: CONGRATULATIONS, srcs: '../images/congratulations.svg'},
                {name: AVATAR_OPTIONS, srcs: '../images/avatar_options.json'},
                {name: AVATAR_TRIMMED_OPTIONS, srcs: '../images/avatar_trimmed_options.json'},
                {name: PROGRESS_GRADIENT_RED, srcs: '../images/progress_gradient.svg'},
                {name: PROGRESS_GRADIENT_GREEN, srcs: '../images/progress_gradient_green.svg'},
                {name: RULES_BUTTON, srcs:'../images/rules_button.svg'},
                {name: RULES_BUTTON_HOVER, srcs:'../images/rules_button_hover.svg'},
                {name: RULES_BACKGROUND, srcs:'../images/rules_background_parchment.svg'},

                {name: APPLAUSE, srcs: '../sounds/applause.mp3'},
                {name: GAMEOVER_SOUND, srcs: '../sounds/game-over.mp3'},
                {name: CLICK, srcs: '../sounds/click.mp3'},
                {name: DRAG, srcs: '../sounds/drag.mp3'},
                {name: FLIP, srcs: '../sounds/flip.mp3'},
                {name: INCORRECT, srcs: '../sounds/incorrect.mp3'},
                {name: PLACE, srcs: '../sounds/place.mp3'},
                {name: TENSION, srcs: '../sounds/tension.mp3'},
                {name: CRACKLING_FIRE, srcs: '../sounds/crackling-fire.mp3'},
                {name: MESSAGE_SEND, srcs: '../sounds/message-send.mp3'},
                {name: MESSAGE_RECEIVE, srcs: '../sounds/message-receive.mp3'},
            ],
        },
    ],
};